import { render } from "./RemercimentPermis.vue?vue&type=template&id=1173c722&scoped=true&ts=true"
import script from "./RemercimentPermis.vue?vue&type=script&lang=ts"
export * from "./RemercimentPermis.vue?vue&type=script&lang=ts"

import "./RemercimentPermis.vue?vue&type=style&index=0&id=1173c722&lang=scss&scoped=true"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1173c722"]])

export default __exports__